export enum LoginType {
  DEFAULT,
  GOOGLE,
  APPLE,
}
